import { render, staticRenderFns } from "./AgreementPolicy.vue?vue&type=template&id=53260a7e&scoped=true"
import script from "./AgreementPolicy.vue?vue&type=script&lang=js"
export * from "./AgreementPolicy.vue?vue&type=script&lang=js"
import style0 from "./AgreementPolicy.vue?vue&type=style&index=0&id=53260a7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53260a7e",
  null
  
)

export default component.exports